import { ISkillProfileUser } from 'app/api/profile/model/profile'
import R from 'app/assets/R'
import BaseText from 'app/components/common/BaseText'
import { convertColumnTable } from 'app/components/tables/BaseTableReport/hook'
import { Pagination } from 'parkway-web-common'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IDataTable } from './type'
import { StatusEnum } from 'app/common/enum'
import { useVerifyPermissionAndRedirect } from 'app/common/use-verify-permission-redirect'

export const useModalHook = () => {
  const { t } = useTranslation()
  const [pagination, setPagination] = useState<Pagination>({
    pageSize: 7,
    current: 1,
  })
  const { user } = useVerifyPermissionAndRedirect()
  const data = [
    {
      status: StatusEnum.ACTIVE,
      data: user?.workinfos,
    },
    {
      status: StatusEnum.ACTIVE,
      data: user?.workinfos,
    },
    {
      status: StatusEnum.ACTIVE,
      data: user?.workinfos,
    },
  ]

  const [visible, setVisible] = useState(false)

  const showModal = () => {
    setVisible(true)
  }

  const handleCancel = () => {
    setVisible(false)
  }

  const columns = useMemo(() => {
    const option = [
      convertColumnTable<ISkillProfileUser>({
        title: t(R.strings.profile_content_industry),
        key: 'industry',
        classNameWidthColumnOverwrite: 'medium-column',
        render: (_, record: ISkillProfileUser) => {
          return (
            <BaseText
              children={record?.industry?.name ?? ''}
              fontWeight="medium"
              opacity="0.7"
              fontSize="xs"
            />
          )
        },
      }),
      convertColumnTable<ISkillProfileUser>({
        title: t(R.strings.skill_group),
        key: 'skill',
        classNameWidthColumnOverwrite: 'normal-column',
        render: (_, record: ISkillProfileUser) => {
          return (
            <BaseText
              children={record?.skill?.name ?? ''}
              fontWeight="medium"
              opacity="0.7"
              fontSize="xs"
            />
          )
        },
      }),
      convertColumnTable<ISkillProfileUser>({
        title: t(R.strings._skill),
        key: 'skill',
        classNameWidthColumnOverwrite: 'normal-column',
        render: (_, record: ISkillProfileUser) => {
          return (
            <BaseText
              children={record?.skill?.name ?? ''}
              fontWeight="semibold"
              opacity="0.9"
              fontSize="xs"
            />
          )
        },
      }),
      convertColumnTable<ISkillProfileUser>({
        title: t(R.strings.profile_content_add_level),
        key: 'levelSkill',
        classNameWidthColumnOverwrite: 'medium-column',
        render: (_, record: ISkillProfileUser) => {
          return (
            <BaseText
              children={record?.levelSkill?.name ?? ''}
              fontWeight="medium"
              fontSize="xs"
              textAlign="right"
            />
          )
        },
      }),
    ]
    return option
  }, [t])

  const handleTableChange = (newPagination: Pagination) => {
    setPagination(newPagination)
  }

  return {
    data,
    columns,
    handleTableChange,
    pagination: {
      ...pagination,
    },
    visible,
    showModal,
    handleCancel,
  }
}
